<template>
  <section class="goods-import-list">
    <goods-top-menu></goods-top-menu>
    <div class="mb-5">
      <b-container fluid>
        <b-row>
          <b-col sm="1">
            <b-button size="sm" class="float-left" v-on:click="importKill()">Прервать</b-button>
          </b-col>
          <b-col sm="11">
            <b-input placeholder="Поиск" class="search-form" size="sm" type="text" v-model="search" v-on:change="updateImportList(1)"></b-input>
            <b-button class="ml-2" size="sm" variant="primary" v-on:click="updateImportList(1)">Ок</b-button>
            <b-button class="ml-2" size="sm" variant="primary" v-on:click="search='', updateImportList(1)">Сброс</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div role="tablist" class="pt-4">
      <b-card no-body class="mb-1" v-for="item in importList" :key="item.id">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
              block href="#"
              variant="danger"
              v-on:click="deleteImport(item.id, 'but-delete-'+ item.id)"
              :ref="'but-delete-'+ item.id"
          >
            <span class="waiting-state">Удалить</span>
            <section class="process-state">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Удаление ...
            </section>
          </b-button>
          <b-button
              block href="#"
              v-b-toggle="'accordion-'+ item.id"
              :variant="getVariant(
                                item.processed,
                                ((item.listError != null && item.isApprove == null)
                                    || item.duplicateDB != null || item.duplicateFile != null),
                                (item.photoTotal || item.pdfTotal),
                                item.isAllDownloaded, item.importSuccess != null)"
          >
            {{ item.fileName }} ({{ item.datetime }})
          </b-button>
        </b-card-header>
        <b-collapse :id="'accordion-'+ item.id" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-container fluid>
              <b-row>
                <b-col class="text-align-left col-4">
                  <b-card-text>Общее количество картинок: {{ item.photoTotal }}</b-card-text>
                  <b-card-text class="pb-4">Загружено картинок: {{ item.photoDownloaded }}
                    ({{ item.photoTotal == 0 ? 0 : Math.round(item.photoDownloaded / item.photoTotal * 100) }}%)
                  </b-card-text>
                  <b-card-text>Общее количество документов: {{ item.pdfTotal }}</b-card-text>
                  <b-card-text>Загружено документов: {{ item.pdfDownloaded }}
                    ({{ item.pdfTotal == 0 ? 0 : Math.round(item.pdfDownloaded / item.pdfTotal * 100) }}%)
                  </b-card-text>
                </b-col>
                <b-col class="col-4">
                  <b-form inline v-on:submit="formSubmit($event)">
                    <div class="width-100">
                      <b-form-file
                          v-model="photoFile"
                          class="mb-2 mr-sm-3 mb-sm-0 "
                          accept="image/*" placeholder="Дефолтная картинка ..."
                      ></b-form-file>
                      <b-button class="mb-2 mr-5 mb-sm-0 btn-load"
                                @click="loadDefPhoto(item.id)"
                                :disabled="photoFile == null"
                                :ref="'photo-load-'+ item.id"
                      >
                        <span class="waiting-state">Загрузить</span>
                        <section class="process-state">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Загрузка...
                        </section>
                      </b-button>

                    </div>
                    <div class="width-100">
                      <div>
                        <b-form-input
                            v-model="defPhotoURL"
                            class="mb-2 mr-sm-4 mb-sm-0 width-100"
                            placeholder="Дефолтная картинка (URL) ..."
                        ></b-form-input>
                      </div>
                      <b-button class="mb-2 mr-5 mb-sm-0 btn-load"
                                @click="loadDefUrlPhoto(item.id)"
                                :disabled="defPhotoURL == null"
                                :ref="'pdf-load-'+ item.id"
                      >
                        <span class="waiting-state">Загрузить</span>
                        <section class="process-state">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Загрузка...
                        </section>
                      </b-button>

                    </div>
                  </b-form>
                </b-col>
                <b-col class="col-4">
                  <div>
                    <a :href="item.photoDefault" v-if="item.photoDefault" target="_blank">
                      <b-img rounded v-bind="imgProps" :src="item.photoDefault" v-if="item.photoDefault"></b-img>
                    </a>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-card v-if="item.processed" class="text-align-left width-100">
                  <div v-if="item.listError != null"
                       class="float-right"
                  >
                    <b-button
                        class="mr-3 btn-sm apply-cancel-import"
                        variant="success"
                        v-on:click="applyImport(item.id)"
                        v-if="item.isApprove == null"
                    >
                      <span v-if="!isApplyingImport">Подтвердить импор</span>
                      <section v-if="isApplyingImport">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Применение ...
                      </section>
                    </b-button>
                    <b-button
                        class="btn-sm apply-cancel-import"
                        variant="danger"
                        v-on:click="deleteImportForDup(item.id, 'but-duplicate-cancel-'+ item.id)"
                        :ref="'but-duplicate-cancel-'+ item.id"
                    >
                      <span class="waiting-state">Отменить</span>
                      <section class="process-state">
                        <span class="spinner-border spinner-border-sm " role="status" aria-hidden="true"></span>
                        Применение ...
                      </section>
                    </b-button>
                  </div>

                  <div v-if="item.duplicateDB != null || item.duplicateFile != null"
                       class="float-right"
                  >
                    <b-button
                        class="mr-2 btn-sm apply-cancel-import"
                        variant="info"
                        v-on:click="duplicateDecision(item.id, 'but-duplicate-save-'+ item.id, 'save')"
                        :ref="'but-duplicate-save-'+ item.id"
                    >
                      <span class="waiting-state">Сохранить</span>
                      <section class="process-state">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Применение ...
                      </section>
                    </b-button>
                    <b-button
                        class="mr-2 btn-sm apply-cancel-import"
                        variant="success"
                        v-on:click="duplicateDecision(item.id, 'but-duplicate-old-'+ item.id, 'old')"
                        :ref="'but-duplicate-old-'+ item.id"
                    >
                      <span class="waiting-state">Оставить старые</span>
                      <section class="process-state">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Применение ...
                      </section>
                    </b-button>
                    <b-button
                        class="btn-sm apply-cancel-import"
                        variant="danger"
                        v-on:click="deleteImportForDup(item.id, 'but-duplicate-cancel-'+ item.id)"
                        :ref="'but-duplicate-cancel-'+ item.id"
                    >
                      <span class="waiting-state">Отменить</span>
                      <section class="process-state">
                        <span class="spinner-border spinner-border-sm " role="status" aria-hidden="true"></span>
                        Применение ...
                      </section>
                    </b-button>

                  </div>
                  <!--                                  old format -->
                  <div v-if="item.rowCounter === null && item.importSuccess != null">
                    <div>Проимпортировано: {{ item.importSuccess }}</div>
                    <div class="mb-2">Ошибок: {{ item.errorCounter ? item.errorCounter : 0 }}</div>

                    <div v-for="error in item.listError" :key="error.message">
                      <div class="count-error-box">{{ error.count }}</div>
                      "{{ error.message }}" { {{ error.valueExample }} }
                    </div>
                  </div>
                  <!--                                  new format -->
                  <div v-if="item.rowCounter !== null && item.importSuccess != null">
                    <div>Обработано строк: {{ item.rowCounter }}</div>
                    <div>Проимпортировано: {{ item.successImport }}</div>
                    <div>Обновлено: {{ item.successUpdate }}</div>
                    <div class="mb-2">Ошибок: {{ item.errorCounter ? item.errorCounter : 0 }}</div>

                    <div v-for="error in item.listError" :key="error.message">
                      <div class="count-error-box">{{ error.count }}</div>
                      "{{ error.message }}" { {{ error.valueExample }} }
                    </div>
                  </div>

                  <div v-if="item.duplicateDB != null || item.duplicateFile != null">
                    <div v-if="item.duplicateDB != null">
                      <div class="mb-2 bold">Дубли в базе</div>
                      <div>Дубликаты по артикулу: {{ item.duplicateDB.article }}</div>
                      <div>Дубликаты по названию: {{ item.duplicateDB.name }}</div>
                    </div>
                    <div v-if="item.duplicateFile != null">
                      <div class="mb-2 mt-3 bold">Дубли в файле</div>
                      <div>Дубликаты по артикулу: {{ item.duplicateFile.article }}</div>
                      <div>Дубликаты по названию: {{ item.duplicateFile.name }}</div>
                    </div>
                  </div>
                </b-card>
              </b-row>
            </b-container>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <pagination
        v-bind:currentPage="currentPage"
        v-bind:goToPage="updateImportList"
        v-bind:perPage="perPage"
        v-bind:countRow="parseInt(countRow)"
        v-bind:perPageNow="limit"
        v-if="amountPage > 1"
    ></pagination>
    <b-modal id="applyImport" hide-footer title="Применение импорта">
      <p class="my-4">Импорт успешно применен.</p>
      <b-button class="mt-3" variant="outline-success" block @click="$bvModal.hide('applyImport')">Ок</b-button>
    </b-modal>
  </section>
</template>

<script>
import goodsTopMenu from '../components/topMenu';
import Pagination from '@/components/components/pagination';
import {config} from "@/config";

export default {
  name: "importList",
  components: {
    goodsTopMenu,
    Pagination
  },
  data() {
    return {
      importList: {},
      limit: 20,
      offset: 1,
      amountPage: 1,
      countRow: 0,
      isImportDelete: {},
      photoFile: null,
      defPhotoURL: null,
      apiDomain: config.apiUrl,
      imgProps: {width: 75, height: 75, class: 'm1'},
      isApplyingImport: false,
      updateFrequency: config.updateFrequency,
      search: ''
    }
  },
  methods: {
    getVariant: function (processed, isError, isFiles, isAllDownloaded, importSuccess) {
      if (!processed || (processed && !isError && !importSuccess && !isFiles && !isAllDownloaded)) {
        return 'secondary';
      }
      if (processed && ((!isError && !isFiles) || (isFiles && isAllDownloaded))) {
        return 'success';
      }
      if (processed && !isError && (!isFiles || (isFiles && isAllDownloaded))) {
        return 'success';
      }
      if (processed && !isError && (isFiles && !isAllDownloaded)) {
        return 'info';
      }
      if (isError) {
        return 'warning';
      }

      return 'dark';
    },
    perPage: function (perPage) {
      this.limit = perPage
      this.updateImportList(this.offset)
    },
    updateImportList: function (offset) {

      if (offset === undefined) {
        offset = this.offset;
      } else {
        this.offset = offset;
      }

      var th = this;
      let funcSuccessResponse = (responseData) => {
        th.importList = responseData.importData;
        th.amountPage = responseData.amountPage;
        th.countRow = parseInt(responseData.countRow);
      };
      this.$store.dispatch('SEND_GET', {
        url: '/goods-import/import-list/' + this.limit + '/' + offset + '?search='+ encodeURIComponent(this.search),
        th: th,
        getSuccessResponse: funcSuccessResponse,
        showSuccessMessage: false
      });

    },
    deleteImport: function (id, ref) {
      this.$refs[ref][0].$el.classList.add('toggle');
      var th = this;
      this.$store.dispatch('SEND_GET', {
        url: '/goods-import/delete/' + id,
        th: th,
        getResponse: () => {
          th.$refs[ref][0].$el.classList.remove('toggle');
        },
        getSuccessResponse: (data) => {
          if (data == 7) {
            console.log(data);
          }
          th.importList = th.importList.filter(function (el) {
            if (el.id == id) {
              return false;
            }
            return true;
          });
        },
        showSuccessMessage: false
      });
    },
    deleteImportForDup: function (id, ref) {
      this.$refs[ref][0].classList.add('toggle');
      var th = this;
      this.$store.dispatch('SEND_GET', {
        url: '/goods-import/delete/' + id,
        th: th,
        getResponse: () => {
          th.$refs[ref][0].classList.remove('toggle');
        },
        getSuccessResponse: (data) => {
          if (data == 7) {
            console.log(data);
          }
          th.importList = th.importList.filter(function (el) {
            if (el.id == id) {
              return false;
            }
            return true;
          });
        }
      });
    },
    loadDefPhoto: function (id) {
      if (this.photoFile == null) {
        return;
      }
      console.log(this.photoFile);
      this.$refs['photo-load-' + id][0].classList.add('toggle');

      let formData = new FormData();
      formData.append('importId', id);
      formData.append('type', 'photo');
      formData.append('file', this.photoFile);

      var th = this;
      this.$store.dispatch('SEND_POST', {
        url: '/goods-import/upload-default',
        parameter: formData,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },
        th: th,
        getResponse: () => {
          th.$refs['photo-load-' + id][0].classList.remove('toggle');
        },
        getSuccessResponse: (data) => {
          if (data == 7) {
            console.log(data);
          }
          th.updateImportList();
        }
      });
    },
    loadDefUrlPhoto: function (id) {
      if (this.defPhotoURL == null) {
        return;
      }
      this.$refs['pdf-load-' + id][0].classList.add('toggle');

      let formData = new FormData();
      console.log(this.defPhotoURL);
      formData.append('url', this.defPhotoURL);
      formData.append('importId', id);

      var th = this;
      this.$store.dispatch('SEND_POST', {
        url: '/goods-import/download-default',
        parameter: formData,
        th: th,
        getResponse: () => {
          th.$refs['pdf-load-' + id][0].classList.remove('toggle');
        },
        getSuccessResponse: (data) => {
          if (data == 7) {
            console.log(data);
          }
          th.updateImportList();
        }
      });
    },
    formSubmit: function (event) {
      if (event) {
        event.preventDefault()
      }
      return false;
    },
    applyImport: function (id) {
      this.isApplyingImport = true;
      var th = this;
      this.$store.dispatch('SEND_GET', {
        url: '/goods-import/import-approve/' + id,
        th: th,
        getResponse: () => {
          th.isApplyingImport = false;
        },
        getSuccessResponse: (data) => {
          if (data == 7) {
            console.log(data);
          }
          th.updateImportList();
        }
      });
    },
    duplicateDecision: function (id, ref, value) {
      this.$refs[ref][0].classList.add('toggle');
      var th = this;
      let funcAfterResponse = () => {
        th.$refs[ref][0].classList.remove('toggle');
        th.isApplyingImport = false;
      };
      this.$store.dispatch('SEND_POST', {
        url: '/goods-import/duplicate-decision/' + id,
        parameter: {'decision': value},
        th: th,
        getResponse: funcAfterResponse,
        getSuccessResponse: (data) => {
          if (data == undefined) {
            console.log(data);
          }
          th.updateImportList();
        },
      });
    },
    importKill: function () {
      var th = this;
      this.$store.dispatch('SEND_GET', {
        url: '/goods-import/kill',
        th: th,
        getSuccessResponse: (data) => {
          if (data == undefined) {
            console.log(data);
          }
          th.updateImportList();
        },
        showSuccessMessage: true
      });
    }
  },
  computed: {
    currentPage: function () {
      return this.offset;
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('product') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
  },
  created() {
    this.updateImportList();
    /*var th = this;
    setInterval(() => {
      if (th.$router.currentRoute.name == 'goodsImportList') {
        th.updateImportList();
      }
    }, th.updateFrequency);*/
  },
}
</script>

<style scoped>
.goods-import-list .card-header .btn-warning.btn-block,
.goods-import-list .card-header .btn-secondary.btn-block,
.goods-import-list .card-header .btn-dark.btn-block,
.goods-import-list .card-header .btn-info.btn-block,
.goods-import-list .card-header .btn-success.btn-block {
  width: 89%;
}

.goods-import-list .card-header .btn-danger.btn-block {
  width: 10%;
  float: right;
}

.toggle .waiting-state {
  display: none;
}

.toggle .process-state {
  display: inline;
}

.process-state {
  display: none;
}

.goods-import-list .btn-block + .btn-block {
  margin-top: 0;
}

.text-align-left {
  text-align: left;
}

.goods-import-list .width-100 {
  width: 100%;
  padding-bottom: 10px;
}

.goods-import-list .btn-load {
  float: left;
  margin-top: 0.5rem;
}

.count-error-box {
  float: left;
  width: 50px;
}
.goods-import-list .search-form {
  display: inline-block;
  width: 90%;
}
</style>